<template>
  <el-container>
    <el-form ref="form"
             :model="form"
             label-position="top"
             label-width="120px"
             @submit.native.prevent="login">
      <el-form-item class="logo">
        <!--
        <img src="https://author.businessexpertpress.com/sites/mp_logo.png">
        <img src="https://author.businessexpertpress.com/sites/bep_logo.png">
        <img src="https://author.businessexpertpress.com/sites/bepmp-logo.png">
        -->
        <img src="https://author.businessexpertpress.com/sites/new_bep_logo.png">
        
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.email"
                  placeholder="Email"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.password"
                  placeholder="Password"
                  type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   native-type="submit">Login</el-button>
      </el-form-item>
      <a style="float:right" href="/forget">Forgot your password?</a>
    </el-form>
    <el-input v-if="timeforget < 0" v-model="timeforget"></el-input>
  </el-container>
</template>

<script>
export default {
  created(){
    console.log(window.location.href);
    // if (window.location.href.endsWith('?test#')){
    //    this.showfgpwd = true;
    // }
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
//      showfgpwd : true,
      timeforget : 1
    };
  },
  methods: {
    login() {
      this.axios({
        method: 'post',
        url: '/login',
        data: this.form,
      })
        .then(res => {
          if (res.data.success) {
            localStorage.token = res.data.token;
            localStorage.userID = res.data.id;
            this.axios.defaults.headers.common.Authorization = `Bearer ${
              localStorage.token
            }`;
            this.$router.push(
              this.$route.query.redirect
                ? this.$route.query.redirect
                : `/user/${localStorage.userID}/profile`
            );
            return;
          }
        })
        .catch(err => {
          this.$message({
            message: 'Login fail!',
            type: 'error',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-container {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-form {
    .el-form-item.logo {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        height: 150px;
      }
    }
    .el-form-item {
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue